import { Routes } from '@angular/router';

export const routes: Routes = [
	{ path: '', redirectTo: 'error', pathMatch: 'full' },
	{
		path: 'error',
		loadComponent: () =>
			import('@pages/landing/landing.component').then(mod => mod.LandingComponent),
	},
	{
		path: 'info',
		loadComponent: () => import('@pages/info/info.component').then(mod => mod.InfoComponent),
	},
	{
		path: ':code/:callbackUrl',
		loadComponent: () =>
			import('@pages/landing/landing.component').then(mod => mod.LandingComponent),
	},
	{
		path: ':code',
		loadComponent: () =>
			import('@pages/landing/landing.component').then(mod => mod.LandingComponent),
	},
	{ path: '**', redirectTo: 'error' },
];
